import Model from './Model'

export default class SourceType extends Model
{
    resource()
    {
    return 'source_type'
    }
}